import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DashboardService } from '../dashboard/dashboard.service';
import { AvaliacaoService } from './avaliacao.service';
import { ApiConService } from '../shared/api-con.service';
import { JsonReturn, ObjectParam } from '../shared/interface/generic-interface';
import { NotificationService } from '../shared/notification.service';
import { NgIf, NgTemplateOutlet, NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-modal-avaliacao',
    templateUrl: './modal-avaliacao.component.html',
    styleUrls: ['./modal-avaliacao.component.css'],
    standalone: true,
    imports: [NgIf, NgTemplateOutlet, NgFor, FormsModule]
})
export class ModalAvaliacaoComponent {

  hoverIndex: number = 0;
  controleInicioModal: boolean = true
  controleAvaliacaoModal: boolean = false
  paginaAtual: 'inicio' | 'avaliacao' | 'final' = 'inicio';
  observacao: string = '';
  pesquisaAvaliacaoID: number = null;
  @Input() momento: string;  
  @Output() closeModal = new EventEmitter<void>();
  categorias: any;
  objPesquisa: any;

  estrelas = [
    {selecionado : false, indice: 1},
    {selecionado : false, indice: 2},
    {selecionado : false, indice: 3},
    {selecionado : false, indice: 4},
    {selecionado : false, indice: 5}  
  ]


  constructor(
      public dashboardService: DashboardService,
      public avaliacaoService: AvaliacaoService,
      private apiConService: ApiConService,
      private notificationService: NotificationService
  ) {}

  ngOnInit(){
    this.getAvaliacao();
    this.configInicial();
  }

  async getAvaliacao() {
    try {
      const [pesquisa] = await this.avaliacaoService.getAvaliacaoPesquisa(this.momento);
      if (!pesquisa) return;

      this.objPesquisa = pesquisa;
      this.pesquisaAvaliacaoID = pesquisa.PesquisaAvaliacaoID;

      this.categorias = (pesquisa.avaliacaoItem ?? []).map(cat => ({
        ...cat,
        hoverIndex: 0,
        estrelas: Array.from({ length: 5 }, (_, i) => ({
          indice: i + 1,
          selecionado: false
        }))
      }));

    } catch (e) {
      console.error("Erro ao carregar avaliação:", e);
    }
  }

  irParaAvaliacao() {
    this.paginaAtual = 'avaliacao';
  }

  async enviarRespostaAvaliacao() {
    const todasTemNota = this.categorias.every(cat => cat.nota !== undefined && cat.nota !== null);

    if (!todasTemNota) {
      this.notificationService.showInformativo("É necessário avaliar todas as categorias!");
      return; 
    }

    const payload = {
      observacao: this.observacao ?? '',
      avaliacoes: this.categorias.map(cat => ({
        PesquisaAvaliacaoItemID: cat.PesquisaAvaliacaoItemID,
        NotaAvaliacao: cat.nota ?? 0
      }))
    };

    const { nome, cnpj } = await this.configInicial();

    const objParam: ObjectParam = {
      pesquisaAvaliacaoResultado: {
        PesquisaAvaliacaoID: this.pesquisaAvaliacaoID,
        JSONResposta: JSON.stringify(payload), 
        Cliente: nome,
        CnpjCpf: cnpj
      }
    };

    try {
      await this.avaliacaoService.salvarRespostaAvaliacao(objParam);
      console.log('Avaliação salva com sucesso!');
    } catch (error) {
      console.error('Erro ao enviar avaliação:', error);
    }
    this.paginaAtual = 'final';
  }

  iniciar(){
    this.controleInicioModal = false;
    this.controleAvaliacaoModal = true;
  }

  
  setHover(item: any, indice: number) {
    item.hoverIndex = indice;
  }

  clearHover(item: any) {
    item.hoverIndex = 0;
  }

  alterarAvaliacao(item: any, indice: number) {
    item.estrelas.forEach((estrela, i) => {
      estrela.selecionado = (i + 1) <= indice;
    });
    item.nota = indice;
  }

  onFechar() {
    this.closeModal.emit();
  }

  async configInicial() {
    const dadosClientes = await this.apiConService.patchInit();

    const clienteInfo = {
      nome: dadosClientes.response.distribuidora.nome,
      cnpj: dadosClientes.response.distribuidora.cnpj
    };
    return clienteInfo;
  }
}
